import React from 'react';

const BroadcastIcon = ({ extraClasses, size = "small" }) => {
  return (
    <span
      role="img"
      className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}>
      <span className={`oc-o-icon--broadcast icon-svg fa-icon-svg fa-icon-svg--${size}`}>
        <svg viewBox="0 0 11 10">
          <g
            transform="translate(-138 -68)"
            fill="none"
            fillRule="evenodd"
          >
            <path stroke="#707576" d="M139 68.5h9V74h-9z" />
            <path
              stroke="#707576"
              strokeLinecap="square"
              d="M143.5 74.375v2.25m1.923 0h-3.846"
            />
          </g>
        </svg>
      </span>
    </span>
  );
};

export default BroadcastIcon;
